import { TableFilterConfig } from '../models/table-filter-config';
import { Pipe, PipeTransform } from '@angular/core';
import { CollectionFilterKey } from '@web/common';
import { isNil, Nillable } from '@web/utils';

@Pipe({
  name: 'filterConfigByKey',
  standalone: true,
})
export class FilterConfigByKeyPipe<Filter> implements PipeTransform {
  public transform(
    filters: TableFilterConfig<Filter>[],
    filterKey: CollectionFilterKey<Filter>,
  ): Nillable<TableFilterConfig<Filter>> {
    if (isNil(filters)) {
      return;
    }

    const config = filters.find(({ key }) => key === filterKey);

    if (isNil(config)) {
      return;
    }

    return config;
  }
}
